export const isDevSite = () => window.location.href.match(/localhost|127\.0\.0\.1|192\.168/);

/**
 * Staging is the *build* (VITE_APP_ENV) or any hostname that contains
 * "staging". The Firebase hosting URL is staging-admin-site-aad2e.web.app;
 * matching only `staging.helm` silently treated that host as production.
 */
export const isStagingSite = () => {
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_APP_ENV === 'staging') {
    return true;
  }
  try {
    return /staging/i.test(window.location.hostname);
  } catch {
    return false;
  }
};

export const isTestSite = () => window.location.href.match(/test\.helm/i);
export const isProduction = () => !isStagingSite() && !isTestSite() && (!isDevSite() || localStorage.getItem('useProdDataInDev') === 'true');

export const useTestData = localStorage.getItem('testData') === 'true' || isStagingSite() || isTestSite();
// will only be used to tint color on the staging and production sites when testData is true
export const useTestDataRemote = localStorage.getItem('testDataRemote') === 'true' || isStagingSite();
